import { Button } from "@material-ui/core";
import SendIcon from '@mui/icons-material/Send';

export const SaveButton = ({ disabled }) => {
    return (
        <Button size="large" color='secondary' disabled={disabled} startIcon={<SendIcon />} type="submit" variant='outlined'>
            {disabled ? 'En cours de soumission...' : 'SAUVEGARDER'}
        </Button>
    );
};